import React from "react";
import Icon from "./icons";

interface BodyGroupHeadingProps {
    title?: string;
    subtitle?: string;
    boldsubtitle?: boolean;
    showHr?: boolean;
    children?: React.ReactNode;
    className?: string;
    info?: string;
}

const BodyGroupHeading: React.FC<BodyGroupHeadingProps> = ({
    title,
    subtitle,
    boldsubtitle = false,
    children,
    showHr = true,
    className = "",
    info,
}) => {
    return (
        <div className={className + " py-4" + (showHr ? " border-b-[1px] border-gray-400 border-solid" : "")}>
            {title && (
                <div className="flex items-center gap-1">
                    <h2 className="text-lg font-semibold">{title}</h2>
                    {info && (
                        <span className="cursor-pointer text-secondary">
                            <Icon name="info" size={16} title={info} />
                        </span>
                    )}
                </div>
            )}
            {subtitle && (
                <p className={boldsubtitle ? "font-semibold text-md uppercase" : "text-sm text-gray-600"}>{subtitle}</p>
            )}
            {children}
        </div>
    );
};

export default BodyGroupHeading;
